import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const OPTIONS = [
  { value: "6'8\"", label: "6'8\"" },
  { value: "7'",    label: "7'"    },
  { value: "8'",    label: "8'"    },
];

const DEFAULT = "6'8\"";

const DoorHeight = ({ value = { value: '', label: '' }, onChange, disabled = false }) => {
  const [selected, setSelected] = useState(value?.value || DEFAULT);

  useEffect(() => { setSelected(value?.value || DEFAULT); }, [value?.value]);

  const handleChange = (e) => {
    const v = e.target.value;
    const label = OPTIONS.find(o => o.value === v)?.label || v;
    setSelected(v);
    onChange({ value: v, label });
  };

  return (
    <div className="a-container">
      <label htmlFor="SdDoorHeight">Door Height</label>
      <select id="SdDoorHeight" value={selected} onChange={handleChange} disabled={disabled}>
        {OPTIONS.map(o => (
          <option key={o.value} value={o.value}>
            {selected === o.value ? `${o.label} ✔` : o.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DoorHeight;
